import React from 'react';

import { Button } from 'design-system/Form';
import { Tooltip } from 'design-system';
import { ButtonType } from 'corp/components/Lookup/LookupTypes';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { WithPlaySound } from 'react-scale/corp/components/WithPlaySound';
import { soundProbability } from 'react-scale/corp/hooks/useIsPastReleaseDate';

interface ICorpButtonsProps {
  objectId: string;
  buttons: ButtonType[];
  refresh: () => void;
  orientation?: string;
}

interface ICorpButtonProps {
  buttonProps: ButtonType;
  objectId: string;
  refresh: () => void;
}

function CorpButton(props: ICorpButtonProps) {
  return (
    <>
      <div className="corp-button">
        <Tooltip title={props.buttonProps.tooltip}>
          <div>
            <WithPlaySound soundUrl={props.buttonProps.alertSound} probability={soundProbability}>
              <Button
                type="danger"
                requireConfirmation={true}
                textTransform="none"
                disabled={props.buttonProps.disabled}
                onClick={async () => {
                  try {
                    const result = await apiFetch(
                      null,
                      `corp-api/lookup/${props.objectId}/runCommand/${props.buttonProps.commandName}`,
                      {
                        method: 'POST',
                        body: props.buttonProps.args,
                      },
                    );
                    if (props.buttonProps.alertResult) {
                      alert(result);
                    }
                    props.refresh();
                  } catch (error) {
                    defaultApiFetchErrorHandler(error, { handleHttp: true });
                  }
                }}
              >
                {props.buttonProps.text}
              </Button>
            </WithPlaySound>
          </div>
        </Tooltip>
      </div>
      <style jsx>{`
        .corp-button {
          margin: 16px 0;
        }
      `}</style>
    </>
  );
}

export default function CorpButtons(props: ICorpButtonsProps) {
  const orientation = props.orientation ?? 'column';
  return (
    <div className={'corp-buttons corp-buttons--' + orientation}>
      {props.buttons.map((item, i) => (
        <CorpButton key={i} buttonProps={item} refresh={props.refresh} objectId={props.objectId} />
      ))}
      <style jsx>{`
        .corp-buttons--row {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
        }

        .corp-buttons--row .corp-button {
          margin-right: 10px;
        }
      `}</style>
    </div>
  );
}
